import { Button, Flex, Form } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  CountDropdown,
  ResortDropdown,
  SessionTypeSelector,
  SkillSelector,
} from "../../../../components";
import { CoachInfoResponse } from "../../../../hooks/Coach/data";
import { pushGtag } from "../../../../plugins/utils";
import { InputRequired } from "../../../../validations/validations";
import "./styles.scss";

const OtherFilter = ({
  form,
  coachInfo,
  params,
  setOpen,
}: {
  form: any;
  coachInfo: CoachInfoResponse;
  params: any;
  setOpen: (val: boolean) => void;
}) => {
  const { t } = useTranslation();
  const [showHalfDaySelector, setShowHalfDaySelector] = useState(false);

  const handleCancel = () => {
    pushGtag({
      event: "book_coach_cancel",
    });

    setOpen(false);
  };

  return (
    <>
      {/* <div className={styles.topContainer}>
        <Flex gap={8}>
          <LeftOutlined
            className={styles.back}
            onClick={() => setSteps(step.DATE)}
          />
          <P1 color="var(--text-content-1)">
            {t("coachInfo.bookModal.title")}
          </P1>
        </Flex>
      </div>
      <Divider className={styles.divider} /> */}
      <Form.Item
        name={"skill_type"}
        label={t("normal.skill.title")}
        rules={[InputRequired(t, "normal.skill.title")]}
      >
        <SkillSelector form={form} skillCode={coachInfo?.skill_codes} />
      </Form.Item>
      <Form.Item
        name={"locations"}
        label={t("home.searchbar.resort.title")}
        rules={[InputRequired(t, "home.searchbar.resort.title")]}
      >
        <ResortDropdown
          form={form}
          skiResortCode={coachInfo?.ski_resort_codes}
          setShowHalfDaySelector={setShowHalfDaySelector}
        />
      </Form.Item>
      {showHalfDaySelector && (
        <Form.Item
          name={"session_type"}
          label={t("normal.sessionType")}
          rules={[InputRequired(t, "normal.sessionType")]}
        >
          <SessionTypeSelector form={form} />
        </Form.Item>
      )}
      <Form.Item
        name={"count"}
        label={t("normal.count.title")}
        rules={[
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (
                Number(getFieldValue("adults")) === 0 &&
                Number(getFieldValue("kids")) === 0
              )
                return Promise.reject(
                  new Error(
                    t("form.required", { name: t("normal.count.title") })
                  )
                );
              return Promise.resolve();
            },
          }),
        ]}
      >
        <CountDropdown form={form} params={params} />
      </Form.Item>
      <Form.Item hidden name={"adults"} initialValue={0} />
      <Form.Item hidden name={"kids"} initialValue={0} />
      <Flex gap={8} justify="flex-end">
        <Button onClick={handleCancel}>{t("normal.cancel")}</Button>
        <Button type="primary" htmlType="submit">
          {t("normal.nextstep")}
        </Button>
      </Flex>
    </>
  );
};

export default OtherFilter;
